import { ArticleFragmentResponse } from '../../../../fragments/article';
import useArticleObject from './useArticleObject';
import useBreadcrumbListObject from './useBreadcrumbListObject';
import useImageObject from './useImageObject';
import useWebpageObject from './useWebpageObject';

const useStructuredData = (article: ArticleFragmentResponse) => {
  const image = useImageObject(article);
  const webpage = useWebpageObject(article);
  const articlePage = useArticleObject(article);
  const breadcrumbList = useBreadcrumbListObject(article);

  return {
    '@context': 'https://schema.org',
    '@graph': [image, webpage, articlePage, breadcrumbList].filter((el) => !!el),
  };
};

export default useStructuredData;
